/*
  "Important Safety Information" section ka button (page ke aakhir mein) usi popup
  ko kholta hai jo "One Formula. Multiple Functions." wale hisse mein safety link
  se khulta hai — wahi design, wahi animation.

  Tareeqa: hum koi naya popup nahi banate. Asli link (`[data-pff-popup-open]`) par
  programmatically click kar dete hain, is liye animation bilkul wahi rehti hai.

  Agar section ki settings mein button ka link daal diya jaye to link hi chalega,
  popup nahi. Aur agar page par safety popup maujood na ho to button pehle ki tarah
  bekaar reh jata hai — kuch toota nahi.
*/
(function () {
  if (window.__rxSafetyPopupInit) return;
  window.__rxSafetyPopupInit = true;

  var BTN = '[class*="important-safety-note-"][class*="__button"]';

  function popupOpener() {
    return document.querySelector('[data-pff-popup-open]');
  }

  /* Button dhoondo — icon ke andar click ho to bhi asli button mil jaye */
  function safetyButton(target) {
    if (!target || !target.closest) return null;
    var el = target.closest(BTN);
    if (!el) return null;
    /* icon wala span alag hai, uska asli parent button lena hai */
    if (/__button-icon$/.test(el.className)) el = el.parentElement && el.parentElement.closest(BTN);
    return el;
  }

  function isLinked(el) {
    var href = el && el.getAttribute && el.getAttribute('href');
    return !!(href && href !== '#' && href.trim() !== '');
  }

  function open(el) {
    var opener = popupOpener();
    if (!opener) return false;
    opener.click();
    /* Popup band hone par focus wapas isi button par aa jaye */
    if (el) {
      var back = function () {
        try { el.focus(); } catch (e) {}
        document.removeEventListener('rx:safety-popup-closed', back);
      };
      document.addEventListener('rx:safety-popup-closed', back);
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    var el = safetyButton(event.target);
    if (!el || isLinked(el)) return;
    event.preventDefault();
    open(el);
  });

  /* Keyboard se bhi khule */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var el = safetyButton(event.target);
    if (!el || isLinked(el)) return;
    event.preventDefault();
    open(el);
  });

  /* Button ko clickable dikhao — bina link wale <span> par cursor aur role lagao */
  function prepare() {
    if (!popupOpener()) return;
    document.querySelectorAll(BTN).forEach(function (el) {
      if (/__button-icon$/.test(el.className)) return;
      if (isLinked(el)) return;
      el.style.cursor = 'pointer';
      /* section ne role="link" + aria-disabled lagaya hota hai — ab ye asal mein
         button hai, is liye durust kar dete hain */
      el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      el.removeAttribute('aria-disabled');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepare);
  } else {
    prepare();
  }

  /* Formula badalne par poora <main> naya aata hai — dobara tayyar kar do */
  document.addEventListener('rx:formula-changed', prepare);
})();
